import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
import FactoryImg from "../../assets/BusBusiness/수진공장.png";
import FactoryImg2 from "../../assets/BusBusiness/기술연구소.png";

import SaleItem1 from "../../assets/BusBusiness/업무1.png";
import SaleItem2 from "../../assets/BusBusiness/업무2.png";
import SaleItem3 from "../../assets/BusBusiness/업무3.png";
import SaleItem4 from "../../assets/BusBusiness/업무4.png";
import SaleItem5 from "../../assets/BusBusiness/업무5.png";
import SaleItem6 from "../../assets/BusBusiness/업무6.png";

const Factory2 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
          <S.NavItem>
              <Link to="/BusBusiness/Factory">
                <div className="kor">생산공장</div>
                <div className="eng">production plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"270px"}>
            <S.NavItem>
              <Link to="/BusBusiness/Factory2">
                <div className="kor">베트남 부품공장</div>
                <div className="eng">Vietnam Parts Manufacturing</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
                          <S.NavItem className="list-inner-item">
                            <Link to="/BusBusiness/Factory">
                              <div className="kor">베트남 법인</div>
                              <div className="eng">Vietnam Production Plant</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/BusBusiness/Factory2">
                              <div className="kor">베트남 부품공장</div>
                              <div className="eng">Vietnam Parts Manufacturing</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/BusBusiness/Factory3">
                              <div className="kor">중국 계림 법인</div>
                              <div className="eng">China Production Plant</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/BusBusiness/Factory4">
                              <div className="kor">파키스탄 법인</div>
                              <div className="eng">Pakistan Production Plant</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/BusBusiness/Factory5">
                              <div className="kor">카자흐스탄 법인</div>
                              <div className="eng">Kazakhstan Production Plant</div>
                            </Link>
                          </S.NavItem>
                          {/* <S.NavItem className="list-inner-item">
                            <Link to="/BusBusiness/Factory6">
                              <div className="kor">코스타리카 법인</div>
                              <div className="eng">Costa Rica Sales Corporation</div>
                            </Link>
                          </S.NavItem> */}
                        </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"베트남 부품공장"} titleeng={"Vietnam Soojin Plant "}/>
            <div className="page-text"></div>
            <S.ImgHolderFullsize>
              <img src={FactoryImg} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">수진공장</div>
                <div className="eng">Soojin Plant</div>
              </div>
            </S.ImgHolderFullsize>

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                  <div className="kor">수진공장 개요</div>
                  <div className="eng">Soojin factory status</div>
                  </div>
                  <div className="kor">
                    생산시작: 2021년 11월 15일
                    <br />
                    <br />
                    ※ 공장규모: 수진공장 건물 2,677평 (임대)
                    <br />※ 주요 생산품목: 중대형 버스 부품
                  </div>
                  <div className="eng">
                    Start of Production: 2021. 11. 15 
                    <br />
                    ※ Factory size: building 8,900 square meters
                    <br />
                    ※ Major products: Mid & large bus parts
                  </div>
                </div>
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">&nbsp;</div>
                    <div className="eng">&nbsp;</div>
                  </div>
                  <div className="kor">
                    &nbsp;
                    <br />
                    To Xuan Moi, Phuc Thang Ward, Phuc Yen City,
                    <br />Vinh Phuc Province, Vietnam
                    <br />jake@dm.co.kr / 84-211-3869-898
                  </div>
                  <div className="eng">
                    &nbsp;
                    <br />
                    To Xuan Moi, Phuc Thang Ward, Phuc Yen City,
                    <br />Vinh Phuc Province, Vietnam
                    <br />jake@dm.co.kr / 84-211-3869-898
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"기술연구소(R&D)"} titleeng={"R&D Center "}/>
            <div className="page-text"></div>
            <S.ImgHolderFullsize>
              <img src={FactoryImg2} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">기술연구소</div>
                <div className="eng">R&D Center</div>
              </div>
            </S.ImgHolderFullsize>

            <div className="page-text">
              <div className="kor"><h2>연구소 주요업무 및 시설</h2></div>
                <div className="eng"><h2>Major Responsibilities & Facilities of the R&D Center</h2></div>
            </div>
            <div className="sale-bus-list2">

  <div className="sale-bus-item2">
    <img src={SaleItem1} className="sale-vietnam-img2" alt="" />

    <div className="sale-bus-name2">
      <div className="kor">디자인<br />(Styling)</div>
      <div className="eng">Design (Styling)</div>
    </div>
  </div>

  <div className="sale-bus-item2">
    <img src={SaleItem2} className="sale-vietnam-img2" alt="" />

    <div className="sale-bus-name2">
      <div className="kor">설계<br />(Engineering)</div>
      <div className="eng">Engineering</div>
    </div>
  </div>

  <div className="sale-bus-item2">
    <img src={SaleItem3} className="sale-vietnam-img2" alt="" />

    <div className="sale-bus-name2">
      <div className="kor">공기역학 시뮬레이션<br />(Aero Dynamics Simnlation)</div>
      <div className="eng">Aero Dynamics Simulation</div>
    </div>
  </div>

  <div className="sale-bus-item2">
    <img src={SaleItem4} className="sale-vietnam-img2" alt="" />

    <div className="sale-bus-name2">
      <div className="kor">전복시험<br />(Rollover Test)</div>
      <div className="eng">Rollover Test</div>
    </div>
  </div>

  <div className="sale-bus-item2">
    <img src={SaleItem5} className="sale-vietnam-img2" alt="" />

    <div className="sale-bus-name2">
      <div className="kor">주행시험장<br />(Road Test)</div>
      <div className="eng">Road Test</div>
    </div>
  </div>

  <div className="sale-bus-item2">
    <img src={SaleItem6} className="sale-vietnam-img2" alt="" />

    <div className="sale-bus-name2">
      <div className="kor">시험 및 평가센터<br />(Test & Assessment Center)</div>
      <div className="eng">Test & Assessment Center</div>
    </div>
  </div>

</div>
            
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Factory2;
